import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const HealthJa = () => {
  useEffect(() => {
    document.documentElement.lang = "ja";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>健康情報の収集・利用に関する同意</PolicyTitle>

      <PolicyText>
        アカウント登録時に、健康情報の収集・利用に同意するかどうかを選択できます。本同意は任意であり、同意しなくても
        pregnancy&baby
        のアカウントを登録できます。ただし、同意しない場合、健康情報の取扱いを必要とする機能をご利用いただけない場合があります。
      </PolicyText>

      <PolicySectionTitle>1. 収集・利用目的</PolicySectionTitle>
      <PolicyHyphenList>
        <li>妊活、不妊治療、妊娠、育児に関する記録・管理機能の提供</li>
        <li>
          生理・排卵日の予測、妊娠週数の計算、検査結果の分析、胎児の成長分析、子どもの成長・発達分析など、利用者が選択したパーソナライズ機能の提供
        </li>
        <li>
          利用者の設定に基づく健康、妊娠、育児に関するリマインダーおよび情報の提供
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. 収集する健康情報</PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>［妊活］</strong>
          <br />
          生理期間、生理周期、最終月経日、生理開始日・終了日、排卵日、排卵検査の日時・画像・結果、妊娠検査の日時・画像・結果、基礎体温、症状、痛み・出血の記録、性交渉の記録、服薬記録、予防接種記録、受診記録、その他利用者が記録する健康関連情報
        </li>
        <li>
          <strong>［不妊治療］</strong>
          <br />
          不妊治療の方法、治療周期、治療開始日・終了日、薬剤・注射の記録、治療スケジュールおよび治療内容
        </li>
        <li>
          <strong>［妊娠］</strong>
          <br />
          出産予定日、妊娠週数・日数、受診記録、予防接種記録、体重記録、エコー画像、胎児計測値（EFW/AC/FL/BPD/HC/CRL）、妊娠前の身長・体重、その他利用者が記録する妊娠関連情報
        </li>
        <li>
          <strong>［育児］</strong>
          <br />
          子どもの生年月日、出生時の身長・体重・頭囲、成長記録、発達評価の記録・スコア、発達に関する写真、早産の有無、健康診査記録、予防接種記録、体温記録、服薬記録、疾病記録
        </li>
      </PolicyList>

      <PolicySectionTitle>3. 保有・利用期間</PolicySectionTitle>
      <PolicyText>
        保存した記録を削除した場合、その記録に関連する情報も削除されます。アカウントを削除した場合、利用者を識別できる個人情報は削除されます。
        ただし、サービスの利用に伴い生成された一部のデータは、利用者を再識別できないよう不可逆的に匿名化した上で、研究、統計分析およびサービス改善を目的として無期限に保有する場合があります。匿名化されたデータを利用者のアカウントまたは個人情報と再び関連付けることはできません。
      </PolicyText>

      <PolicySectionTitle>同意を拒否する権利</PolicySectionTitle>
      <PolicyText>
        本同意は任意であり、同意しなくても pregnancy&baby
        のアカウント登録および健康情報の取扱いを必要としない機能をご利用いただけます。
        ただし、同意しない場合、妊活、不妊治療、妊娠、育児の記録など、健康情報の取扱いを必要とする機能をご利用いただけない場合があります。
      </PolicyText>
    </PolicyContainer>
  );
};

export default HealthJa;
